import { tss } from 'tss-react/mui';

export const useStyles = tss.create(({ theme }) => ({
  page: {
    display: 'flex',
    flexDirection: 'column',
    gap: '30px',
    padding: '30px',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '16px',
    flexWrap: 'wrap',
  },
  errorState: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '12px',
    padding: '20px',
    borderRadius: theme.shape.borderRadius * 2,
    border: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.paper,
  },
  tableContainer: {
    borderRadius: theme.shape.borderRadius * 2,
    boxShadow: theme.shadows[3],
    overflowX: 'auto',
  },
  tableHeadCell: {
    fontWeight: 'bold',
    color: theme.palette.primary.contrastText,
    backgroundColor: theme.palette.primary.main,
    whiteSpace: 'nowrap',
  },
  tableRow: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
  },
  tableCell: {
    color: theme.palette.text.secondary,
    verticalAlign: 'middle',
  },
  audioCell: {
    minWidth: '220px',
  },
  actionsCell: {
    minWidth: '180px',
    whiteSpace: 'nowrap',
  },
  dialogContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    paddingTop: '12px',
  },
  volumeRow: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  volumeControlsRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '18px',
  },
  sliderWrapper: {
    display: 'flex',
    alignItems: 'center',
    flex: '1 1 230px',
    maxWidth: '360px',
  },
  hiddenInput: {
    display: 'none',
  },
  fileRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    flexWrap: 'wrap',
  },
  fileName: {
    color: theme.palette.text.secondary,
    wordBreak: 'break-all',
  },
  fileHint: {
    color: theme.palette.text.secondary,
  },
  previewRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    flexShrink: 0,
  },
  deleteMessage: {
    color: theme.palette.text.secondary,
  },
}));
